export default __webpack_public_path__ + "static/media/party.8203f63e.png";